import * as types from './types';
import { loading, success, error } from 'State/actions';

export const fetchData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.USER_PROFILE_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('Account/UserProfile');

      dispatch(success(types.USER_PROFILE_FETCH, { data: response.data.Data }));
    } catch (ex) {
      dispatch(error(types.USER_PROFILE_FETCH_ERROR, ex));
    }

    dispatch(loading(types.USER_PROFILE_FETCHING, false));
  };
};

export const saveUserProfile = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.USER_PROFILE_SUBMITTING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate('Account/UserProfile', data);

      dispatch(success(types.USER_PROFILE_SUBMIT));
      dispatch(fetchData());
    } catch (ex) {
      dispatch(error(types.USER_PROFILE_SUBMIT_ERROR, ex));
    }

    dispatch(loading(types.USER_PROFILE_SUBMITTING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/userprofile/state/userprofile/actions.js